
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import PropTypes from "prop-types";
import React, {PureComponent} from "react";
import {
	View,
} from "react-native";
import ResponsiveStylesheet from "react-native-responsive-stylesheet";
import Breakpoints from "react-native-dimensions-breakpoints";

import StyledText from "./StyledText";
import StyledIcon from "./StyledIcon";
import Style from "ae-style";

var styles = ResponsiveStylesheet.createSized("min-direction", {
	0: {
		header: {
			flexDirection: "row",
			alignItems: "center",
			justifyContent: "space-between"
		},
		icon: {
			marginRight: 0
		}
	},
	512: {
		header: {
			flexDirection: "row",
			alignItems: "center",
			justifyContent: "space-between"
		},
		icon: {
			marginRight: Style.layout.marginLarge
		}
	}
});

export default class Heading extends PureComponent {
	render(){
		var props = this.props;
		var title = props.title;
		var contrast = props.contrast;
		var iconName = props.icon;
		var size = props.size;

		var icon = iconName ? (
			<StyledIcon style={styles.icon} contrast={contrast} largeHeading name={iconName} />
	) : null;

		var sizeTitle = "smallHeading";
		if (Breakpoints.smallerThan("mobile")) {
			sizeTitle = "emphasized";
		}
		if (Breakpoints.smallerThan("small")) {
			sizeTitle = "standard";
		}
		if (size) sizeTitle = size;

		return (
			<View style={styles.header}>
				{icon}
				<StyledText id={props.id} contrast={contrast} size={sizeTitle} bold>
					{title}
				</StyledText>
				{props.children}
			</View>
		);
	}
}
